import { render, staticRenderFns } from "./FeaturesSection.vue?vue&type=template&id=519607dc&scoped=true"
import script from "./FeaturesSection.vue?vue&type=script&lang=js"
export * from "./FeaturesSection.vue?vue&type=script&lang=js"
import style0 from "./FeaturesSection.vue?vue&type=style&index=0&id=519607dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519607dc",
  null
  
)

export default component.exports